/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationProfessionalsAliases {
  FRAGMENT_AMOUNT_PROFESSIONALS = 'fragment-amount-professionals',
  FRAGMENT_EMPLOYEES = 'fragment-employees',
  LAYOUT_0 = 'layout-0',
  PANEL_0 = 'panel-0',
  PANEL_TITLE = 'panel-title',
  TAB_AMOUNT_PROFESSIONALS = 'tab-amount-professionals',
  TAB_CONTROL = 'tab-control',
  TAB_EMPLOYEES = 'tab-employees',
  TEXT_3 = 'text-3',
}
export { ProviderAccreditationProfessionalsAliases };
